import IMask from 'imask';

import dispatchCustomEvent from '../../../utils/dispatch-custom-event';
import Base from '../../base';

import formEvents from './calculator-form-events';
import formOptions from './calculator-form-options';

class CappeFloore extends Base {
	constructor(el) {
		super(el);

		this.isinInput = this.query('[name="isin"]');
		this.underlyingRateInput = this.query('[name="expectedUnderlyingRate"]');

		this.start();
	}

	get formData() {
		return {
			expectedUnderlyingRate: this.underlyingRateFormatted.unmaskedValue,
			isin: this.isinInput.value,
		};
	}

	start() {
		formOptions.set(this.options);

		this.underlyingRateFormatted = new IMask(this.underlyingRateInput, {
			mask: Number,
			scale: formOptions.get('decimalPrecision'),
			thousandsSeparator: formOptions.get('thousandSeparator'),
			radix: formOptions.get('decimalSeparator'),
			padFractionalZeros: true,
			signed: false,
		});

		this.on('submit');
	}

	onSubmit(e) {
		e.preventDefault();

		const { formData } = this;

		dispatchCustomEvent(this.el, formEvents.FORM_SUBMITTED, formData);
	}
}

export default CappeFloore;
